import axios from 'axios';

export function createApiClient({ baseURL, timeout = 10000 } = {}) {
  return axios.create({
    baseURL: `${baseURL}/api`,
    timeout,
  });
}
